<script>
  let {
    /** @type {float} number between 0 and 1 */
    focal_point_x = $bindable(),
    /** @type {float} number between 0 and 1 */
    focal_point_y = $bindable(),
    width: image_width,
    height: image_height,
    /** @type {() => void} Called after the user sets the point (e.g. to clear an auto flag) */
    onchange,
  } = $props();

  function set_focal_point_by_click(event){
    const rect = event.currentTarget.getBoundingClientRect();
    let clientX, clientY;

    // Check if it's a touch or mouse event
    if(event.touches && event.touches.length > 0) {
      clientX = event.touches[0].clientX;
      clientY = event.touches[0].clientY;
    } else {
      clientX = event.clientX;
      clientY = event.clientY;
    }
    const relativeX = (clientX - rect.left) / rect.width;
    const relativeY = (clientY - rect.top) / rect.height;

    // Ensure the relative positions are within the range [0, 1]
    focal_point_x = Math.max(0, Math.min(1, relativeX));
    focal_point_y = Math.max(0, Math.min(1, relativeY));
    onchange?.();
  }

  function set_focal_point_by_key(event) {
    event.preventDefault();
    const step = 0.1;
    if (event.key === 'ArrowDown') {
      focal_point_y = Math.min(1, focal_point_y + step);
    } else if (event.key === 'ArrowUp') {
      focal_point_y = Math.max(0, focal_point_y - step);
    } else if (event.key === 'ArrowLeft') {
      focal_point_x = Math.max(0, focal_point_x - step);
    } else if (event.key === 'ArrowRight') {
      focal_point_x = Math.min(1, focal_point_x + step);
    }
    onchange?.();
  }
</script>

<button
  class="focal-point-wrapper"
  onpointerup={set_focal_point_by_click}
  onkeydown={set_focal_point_by_key}
  style:--image-aspect-ratio={image_width && image_height ? `${image_width} / ${image_height}` : '1 / 1'}
  aria-label="Set focal point"
>
  <div 
    style:left={focal_point_x * 100 + "%"} 
    style:top={focal_point_y * 100 + "%"} 
    class="focal-point"
  >
    <div>
    </div>
  </div>
</button>

<style>
  .focal-point-wrapper {
    position: absolute;
    inset: 0;
    margin: auto;
    width: auto;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    aspect-ratio: var(--image-aspect-ratio);
    --fp-size: 60px;
    cursor: crosshair;
    border: none;
    background: transparent;
    padding: 0;
    /* the reticle trims cleanly at the image edge instead of bleeding out */
    overflow: hidden;
  }
  .focal-point {
    position: absolute;
    pointer-events: none;     
    will-change: left, top;
    transition: top 150ms var(--accelerated-ease-out), left 150ms var(--accelerated-ease-out);
  }
  /* Focus ring, camera-style and nothing more: an editing-colored circle with
     a white halo plus a small center dot. The circle outline is the familiar
     "focus point" convention — readable on any image without extra ornament. */
  .focal-point::before {
    /* center dot */
    content: "";
    width: 6px;
    height: 6px;
    background-color: var(--editing);
    border: 1.5px solid white;
    z-index: 3;
    border-radius: 50%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
  }
  .focal-point::after {
    /* ring */
    content: "";
    width: var(--fp-size);
    height: var(--fp-size);
    border: 2px solid var(--editing);
    border-radius: 50%;
    box-shadow:
      0 0 0 1.5px rgb(255 255 255 / 0.95),
      inset 0 0 0 1.5px rgb(255 255 255 / 0.95),
      0 2px 6px rgb(0 0 0 / 0.25);
    z-index: 2;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
  }
</style>